import Rails from "@rails/ujs";
import Dropzone from "dropzone";
import { Controller } from "stimulus";

import DropzoneDirectUploadController from "../helpers/dropzone_direct_upload_controller";
import { getMetaValue } from "../helpers/stimulus";
import { pl as localePl } from "../helpers/dropzone.i18n";

Dropzone.autoDiscover = false;

export default class extends Controller {
  static targets = ["wrapper", "input", "submit", "previewsContainer", "previewTemplate"];
  static values = { imageValidation: Boolean, acceptedFiles: String };

  connect() {
    this.dropZone = this._createDropzone();
    this._hideFileInput();
    this._bindDropzoneEvents();

    this.files = [];
    this.userWantsToSubmit = false;
  }

  handleSubmitForm(e) {
    Rails.disableElement(this.submitTarget);

    // If files were not uploaded, upload files and send the form later
    if (this.files.length > 0 && this.files.some((file) => file.status !== Dropzone.SUCCESS)) {
      e.preventDefault();
      e.stopImmediatePropagation();

      this.files.forEach((file) => {
        const uploadController = new DropzoneDirectUploadController(this, file);
        uploadController.start();
      });

      this._disableDropzone();
      this.userWantsToSubmit = true;
    }
  }

  get url() {
    return this.inputTarget.getAttribute("data-direct-upload-url");
  }

  _hideFileInput() {
    this.inputTarget.disabled = true;
    this.inputTarget.style.display = "none";
  }

  _bindDropzoneEvents() {
    this.dropZone
      .on("addedfile", (file) => {
        file.previewElement.querySelector(".dz-progress").style.display = "none";
      })
      .on("removedfile", (file) => {
        // Remove file from file list
        this.files = this.files.filter((f) => f.upload.uuid !== file.upload.uuid);
      })
      .on("queuecomplete", () => {
        if (this.userWantsToSubmit) {
          this._submitForm();
        }
      })
      .on("error", (file) => {
        this.userWantsToSubmit = false;
      });
  }

  _submitForm() {
    const { disabled } = this.submitTarget;
    this.submitTarget.disabled = false;
    this.submitTarget.focus();
    this.submitTarget.click();
    this.submitTarget.disabled = disabled;
  }

  _createDropzone() {
    return new Dropzone(this.wrapperTarget, {
      ...localePl,
      url: this.url,
      headers: { "X-CSRF-Token": getMetaValue("csrf-token") },
      maxFiles: 30,
      maxFilesize: 20,
      autoQueue: false,
      previewsContainer: this.previewsContainerTarget,
      previewTemplate: this.previewTemplateTarget.innerHTML,
      accept: (file, done) => {
        this.files.push(file);
        done();
      },
      acceptedFiles: this.imageValidationValue ? this.acceptedFilesValue : undefined,
    });
  }

  _disableDropzone() {
    this.dropZone.removeEventListeners();
  }
}
